import React from 'react'
import { LabeledTextarea } from '@apex/component-library'

interface FromAccountProps {
  displayedValue: string
}

export const FromAccount = ({ displayedValue }: FromAccountProps) => {
  return (
    <LabeledTextarea
      label='From Account'
      aria-label='From Account'
      rows={1}
      isRequired
      width='100%'
      isReadOnly
      defaultValue={displayedValue}
      data-testid='fromAccount'
    />
  )
}
